/**
 * DemoBanner — sticky pomarańczowy pasek widoczny na każdej stronie
 * gdy user.demo_mode === true. Nie można go zamknąć (celowo — user
 * musi cały czas widzieć że pracuje na fake danych).
 *
 * Widoczność sterowana pojedynczą flagą `visible` przekazaną z
 * `MainLayout`. Backend zwraca `demo_mode` w `GET /api/auth/me`
 * oraz `X-PAX-Mode: demo` header per request.
 */
import { AlertTriangle } from "lucide-react";

const DemoBanner = ({ visible }) => {
  if (!visible) return null;

  return (
    <div
      className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-md border-b-2 border-amber-700"
      data-testid="demo-mode-banner"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-full mx-auto px-4 py-2 flex items-center justify-center gap-3">
        <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={2.5} />
        <span className="text-sm font-semibold tracking-wide" data-testid="demo-mode-banner-text">
          🟠 DEMO MODE — Wszystkie dane prezentowane w aplikacji są demonstracyjne.
        </span>
      </div>
    </div>
  );
};

export default DemoBanner;
